/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/component-selector */
import { Component, Input } from '@angular/core';

@Component({
	selector: 'breadcrumb',
	templateUrl: './breadcrumb.component.html',
	styleUrl: '../../assets/styles/breadcrumb.scss'
})
export class BreadcrumbComponent {
	@Input() breadcrumbList: any[] = [];
}
